import { GatewayContent } from './general';
import React from 'react';
import { RedirectWatcher } from './RedirectWatcher';
import { SalesforceSyncWatcher } from '@ui/SalesforceSyncWatcher';
import { SessionActivityWatcher } from '@ui/SessionActivityWatcher';
import { Sonar } from '../app/Sonar';
import { When } from 'react-if';

import { OnboardingView, OrganizationView } from './onboarding';
import {
	useCurrentOrganization,
	useOnboardingProgress,
	useOrganizations,
	useSonarSelector
} from '@hooks';

export const AuthorizedView: React.FC = () => {
	const { loading, progress } = useOnboardingProgress();
	const currentOrganization = useCurrentOrganization();

	const organizationsLoading = useSonarSelector(useOrganizations.selectors.isRequested);

	const ready = !loading && progress &&
		(!organizationsLoading || (organizationsLoading && currentOrganization?.hasSalesforceData));

	if (!ready) {
		return <GatewayContent />;
	}

	const {
		isSalesforceConnected,
		isSalesforceSynced,
		missingSalesforceSyncPermission
	} = progress;

	const isOnboarding = !currentOrganization && !progress.organizationId;
	const isRootOrganization = currentOrganization?.id === progress.organizationId;

	const showOnboarding = isOnboarding || isRootOrganization;
	const showOrganization = !showOnboarding && (!currentOrganization?.hasSalesforceData || !isSalesforceSynced);

	const showApp = currentOrganization?.hasSalesforceData &&
		isSalesforceConnected &&
		isSalesforceSynced &&
		!missingSalesforceSyncPermission;

	return (
		<>
			<SalesforceSyncWatcher showNotifications={ showApp } />
			<SessionActivityWatcher />
			<RedirectWatcher />
			<When condition={ showApp }>
				<Sonar />
			</When>
			<When condition={ !showApp && showOnboarding }>
				<OnboardingView />
			</When>
			<When condition={ !showApp && showOrganization }>
				<OrganizationView />
			</When>
		</>
	);
};
